import { render, staticRenderFns } from "./InterestsSelection.vue?vue&type=template&id=76207276&scoped=true&"
import script from "./InterestsSelection.vue?vue&type=script&lang=js&"
export * from "./InterestsSelection.vue?vue&type=script&lang=js&"
import style0 from "./InterestsSelection.vue?vue&type=style&index=0&id=76207276&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76207276",
  null
  
)

export default component.exports